import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=454c0ef2&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=454c0ef2&lang=scss&scoped=true&"
import style1 from "./Users.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c0ef2",
  null
  
)

export default component.exports